export default "__VITE_ASSET__CqLI6TJn__"